// extracted by mini-css-extract-plugin
export default {"linkedbutton":"linkedbutton__xuB5N","fullWidth":"fullWidth__baO7b"};